<template>
    <view>
    <HeaderPage/>
    <div class="container">
        <div class="row">
            <div class="col-md-8 news_page_box" v-if="columnId!=82">
                <div class="path">
                    <i class="fa fa-television"></i>当前位置： <span v-if="newsColumn.name">{{newsColumn.name}}&nbsp;>&nbsp;</span>{{ subColumnName }}
                </div>
                <div class="column_photo" v-if="columnId==80">
                    <div class="row">
                        <div class="col-md-4 col-xs-6" v-for="(item,index) in newsList" :key="index">
                            <div class="index_photo_item">
                                <a :href="item.link" v-if="item.type==4" target="_blank">
                                    <img :src="item.cover">
                                    <div class="video_play"><i class="iconfont icon-shipin5"></i></div>
                                </a>
                                <router-link :to="'/special/node_'+item.basic_id+'.html'" v-else-if="item.type==3" target="_blank">
                                    <img :src="item.cover">
                                    <div class="video_play"><i class="iconfont icon-shipin5"></i></div>
                               </router-link>
                                <router-link :to="'/video/show-'+item.basic_id+'.html'" v-else-if="item.type==2" target="_blank">
                                    <img :src="item.cover">
                                    <div class="video_play"><i class="iconfont icon-shipin5"></i></div>
                               </router-link>
                                <router-link :to="'/album/show-'+item.basic_id+'.html'" v-else-if="item.type==1" target="_blank">
                                    <img :src="item.cover">
                                    <div class="video_play"><i class="iconfont icon-shipin5"></i></div>
                                </router-link>
                                <router-link :to="'/article/show-'+item.basic_id+'.html'" v-else target="_blank">
                                    <img :src="item.cover">
                                    <div class="video_play"><i class="iconfont icon-shipin5"></i></div>
                                </router-link>
                                <p> {{item.title}} </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="coloum_list">
                    <div class="news-a" v-for="(item,index) in newsList" :key="index">
                        <span class="date">{{formatTimestamp(item.ctime)}}</span>
                        <a :href="item.link" v-if="item.type==4" target="_blank">
                            
                            {{item.title}}
                        </a>
                        <router-link :to="'/special/node_'+item.basic_id+'.html'" v-else-if="item.type==3" target="_blank">
                            
                            {{item.title}}
                        </router-link>
                        <router-link :to="'/video/show-'+item.basic_id+'.html'" v-else-if="item.type==2" target="_blank">
                            
                            {{item.title}}
                        </router-link>
                        <router-link :to="'/album/show-'+item.basic_id+'.html'" v-else-if="item.type==1" target="_blank">
                            
                            {{item.title}}
                        </router-link>
                        <router-link :to="'/article/show-'+item.basic_id+'.html'" v-else target="_blank">
                            
                            {{item.title}}
                        </router-link>
                        <div class="clear"></div>
                    <div class="line" v-if="(index + 1) % 10 == 0"></div> 
                    </div>
                </div>
                <!--'0 => article', 1 => 'album', 2 => 'video', 3 => 'special'-->
                <!--div class="news-list shadow-sm wow fadeInUp">
                    <div class="img">
                        <router-link :to="'/article/show-'+item.basic_id+'.html'" target="_blank"><img :src="item.cover"></router-link>
                    </div>
                    <div class="con">
                        <div class="title">
                            <router-link :to="'/article/show-'+item.basic_id+'.html'" target="_blank">{{item.title}}</router-link> 
                        </div>
                        <div class="dis">
                            <router-link :to="'/article/show-'+item.basic_id+'.html'" target="_blank">{{item.editor}}  </router-link>     
                        </div>
                        <div class="date">
                            <i class="fa fa-clock-o">&nbsp;</i>{{formatTimestamp(item.ctime)}} 
                        </div>
                    </div>
                </div-->
                <div style="text-align:center; position: absolute; top:25%; width: 100%;" v-if="newsList.length <= 0">
                    <div><img src="../../assets/images/nodatamsg.png"  style="width:350px; height:auto;"></div>
                    <div style="color:#999999; margin-top:10px;">暂无相关数据,请稍后重试~</div>
                </div>
                <div id="loading-mask" v-if="isLodding == 1">
                    <div class="loading-wrapper">
                        <span class="loading-dot loading-dot-spin"><i></i><i></i><i></i><i></i></span>
                    </div>
                </div>
                <pageRows
                @change="changePage"
                :current="pagination.p"
                :pageSize="pagination.pageSize"
                :total="totalNum"
                :hideOnSinglePage="hideOnSinglePage"
                :showQuickJumper="true"
                :showTotal="true"
                placement="center"
                v-if="pagination && totalNum" />
            </div>
            <div class="col-md-12 news_page_box" v-if="columnId==82">
                <div class="path">
                    <i class="fa fa-television"></i>当前位置： <span v-if="newsColumn.name">{{newsColumn.name}}&nbsp;>&nbsp;</span>{{ subColumnName }}
                </div>
                <div class="album_photo">
                    <!-- 轮播 -->
                    <div id="demo" class="carousel slide Album_news" data-bs-ride="carousel">

                        <!-- 指标/点 -->
                        <div class="carousel-indicators" style="width:10%">
                            <button type="button" data-bs-target="#demo" v-for="(item,index) in imageNewsTop" :key="index" :data-bs-slide-to="index" :class="index>0?'':'active'"></button>
                        </div>

                        <!-- 幻灯片/轮播 -->
                        <div class="carousel-inner">
                            <div v-for="(item,index) in imageNewsTop" :key="index" :data-bs-slide-to="index" :class="index>0?'':'active'" class="carousel-item">
                                <router-link :to="'/album/show-'+item.basic_id+'.html'" target="_blank"><img :src="item.cover"></router-link>
                                <div class="foucs_text">
                                    <div class="tit">{{item.title}}</div>
                                </div>
                            </div>
                        </div>

                        <!-- 左右控件/图标 -->
                        <button class="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon"></span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
                            <span class="carousel-control-next-icon"></span>
                        </button>
                    </div> 
                    <div class="thumb">
                        <div data-bs-target="#demo" v-for="(item,index) in imageNewsTop" :key="index" :data-bs-slide-to="index" class="thumb_img" :class="index>0?'':'active'">
                            <img :src="item.cover">
                            <div class="tit">{{ item.title }}</div>
                        </div>
                        <div style="clear:both"></div>
                    </div>
                </div>  
                <div style="text-align:center; position: absolute; top:25%; width: 100%;" v-if="newsList.length <= 0">
                    <div><img src="../../assets/images/nodatamsg.png"  style="width:350px; height:auto;"></div>
                    <div style="color:#999999; margin-top:10px;">暂无相关数据,请稍后重试~</div>
                </div>
                <div id="loading-mask" v-if="isLodding == 1">
                    <div class="loading-wrapper">
                        <span class="loading-dot loading-dot-spin"><i></i><i></i><i></i><i></i></span>
                    </div>
                </div>
            </div>
            <div class="col-md-12 news_page_box" v-if="columnId==82" style="margin-top:15px;">
                <div class="column_photo">
                    <div class="index_news_tit">
                            <div class="news_type">图说巧家</div>
                            <div class="clear"></div>
                        </div>
                    <div class="row">
                        <div class="col-md-3 col-xs-6" v-for="(item,index) in imageNews" :key="index">
                            <div class="index_photo_item">
                                <a :href="item.link" v-if="item.type==4" target="_blank">
                                    <img :src="item.cover" class="photoimg">
                                </a>
                                <router-link :to="'/special/node_'+item.basic_id+'.html'" v-else-if="item.type==3" target="_blank">
                                    <img :src="item.cover">
                                </router-link>
                                <router-link :to="'/video/show-'+item.basic_id+'.html'" v-else-if="item.type==2" target="_blank">
                                    <img :src="item.cover">
                                </router-link>
                                <router-link :to="'/album/show-'+item.basic_id+'.html'" v-else-if="item.type==1" target="_blank">
                                    <img :src="item.cover">
                                </router-link>
                                <router-link :to="'/article/show-'+item.basic_id+'.html'" v-else target="_blank">
                                    <img :src="item.cover">
                                </router-link>
                                <p> {{item.title}} </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="text-align:center; position: absolute; top:25%; width: 100%;" v-if="newsList.length <= 0">
                    <div><img src="../../assets/images/nodatamsg.png"  style="width:350px; height:auto;"></div>
                    <div style="color:#999999; margin-top:10px;">暂无相关数据,请稍后重试~</div>
                </div>
                <pageRows
                @change="changePage"
                :current="pagination.p"
                :pageSize="pagination.pageSize"
                :total="totalNum"
                :hideOnSinglePage="hideOnSinglePage"
                :showQuickJumper="true"
                :showTotal="true"
                placement="center"
                v-if="pagination && totalNum" />
            </div>
            <div class="col-md-4 news_page_right" v-if="columnId!=82">
                <RightPage/>
            </div>
        </div>
    </div>
</view>
</template>
<script>
    import { post } from '@/request'; 
    import HeaderPage from '@/components/HeaderUnit.vue'
    import RightPage from '@/components/RightUnit.vue'
    import pageRows from '@/components/PaginationUnit.vue'
    export default {
        components: {
            HeaderPage,
            RightPage,
            pageRows
        },
        data() {
            return {
                columnId: 0,
                isLodding: 1,
                totalNum: 0,
                newsList: [],
                newsColumn: [],
                hideOnSinglePage: true,
                pagination: {
                    pageSize: 27,
                    p: 1
                },
                imageNewsTop: [], 
                imageNews: [], 
                title: '巧家新闻网—巧家县第一新闻门户网站',
                keywords: ['巧家新闻','巧家','白鹤滩','巧家县','巧家新闻网'],
                description: '巧家县第一新闻门户网站，巧家新闻网由中共巧家县委宣传部主办、巧家县人民政府新闻中心承办，是对外宣传推介巧家、展示巧家形象、外界了解巧家的重要网络平台。'
            }
        },
        mounted(){
            this.setTitle();  
            this.setKeywords();  
            this.setDescription();  
       },
        computed: {  
            subColumnName() {  
                return this.newsColumn && this.newsColumn['0'] ? this.newsColumn['0'].name : null;  
            }
        },  
        created() {
            // watch 路由的参数，以便再次获取数据
            this.$watch(
            () => this.$route.params,
            () => {
                this.columnId = this.$route.params.id.replace(/\.html$/, '')
                //console.log(this.columnId)
                this.getNewsList(1)
            },
            // 组件创建完后获取数据，
            // 此时 data 已经被 observed 了
            { immediate: true }
            )

        },
        methods: {
            setTitle() {  
                document.title = this.title; // 设置标题  
            },  
            setKeywords() {  
                const metaKeywords = document.createElement('meta');  
                metaKeywords.name = 'keywords';  
                metaKeywords.content = this.keywords.join(','); // 设置关键词  
                document.head.appendChild(metaKeywords);  
            },  
            setDescription() {  
                const metaDescription = document.createElement('meta');  
                metaDescription.name = 'description';  
                metaDescription.content = this.description; // 设置描述  
                document.head.appendChild(metaDescription);  
            },  
            formatTimestamp(timestamp) {  
                return this.$formatTimeAgo(timestamp); // 调用全局方法  
            }, 
            changePage (pager) { // 分页器回调
                //console.log(pager)
                this.$emit('change', pager)
                this.getNewsList(pager.page)
            },
            async getNewsList(e) {  
                let that = this
                that.isLodding = 1
                let pagenum = e
                try {  
                    const postData = {'page': pagenum,'length': 26 };  
                    const response = await post('column/'+that.columnId, postData);  
                    //console.log(response)
                    that.isLodding = 0
                    document.title = response.column[0].name+'-'+JSON.parse(localStorage.getItem('websiteInfo')).websiteName
                    that.newsList = response.data
                    that.imageNewsTop = response.data.slice(0, 6); // 取前 6 条  
                    that.imageNews = response.data.slice(6); // 取剩下的  
                    that.totalNum = response.total
                    that.newsColumn = response.column
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
        },
    }
</script>
